import React, { useEffect, useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./SaveChangesModal.scss";

export function SaveChangesModal({ changesList, school, submit, ...props }) {
    const [t] = useTranslation();
    const [books, setBooks] = useState([]);

    useEffect(() => {
        setBooks(changesList);
    }, [changesList]);

    const mergeBookLists = (list1, list2) => {
        const bookMap = {};

        list1.forEach((book) => {
            bookMap[book.id] = book;
        });

        list2.forEach((book) => {
            if (bookMap[book.id]) {
                bookMap[book.id] = {
                    ...bookMap[book.id],
                    ...book,
                };
            } else {
                bookMap[book.id] = book;
            }
        });

        return Object.values(bookMap);
    };

    const renderBook = (/** @type {BookSchoolPreRegResource} */ book) => {
        return (
            <div key={book.id} className="book-wrapper">
                <div className="column-wrapper title">
                    <div className="label">{t("Title")}</div>
                    <div className="value" title={book.title}>
                        {book.title}
                    </div>
                </div>
                <div className="column-wrapper isbn">
                    <div className="label">{t("ISBN")}</div>
                    <div className="value">{book.isbn}</div>
                </div>
                {school.schoolActiveNextYear && (
                    <div className="column-wrapper">
                        <div className="label">{t("BookDelivery")}</div>
                        <div className="change">
                            <div className="old">{book.shouldBeReturned ? t("Return") : t("NoReturn")}</div>
                            <div className="new">{!book.shouldBeReturned ? t("Return") : t("NoReturn")}</div>
                        </div>
                    </div>
                )}
                {!school.schoolActiveNextYear && (
                    <div className="column-wrapper">
                        <div className="label">{t("Takeover")}</div>
                        <div className="change">
                            <div className="old">{!book.shouldTakeOver ? t("Yes") : t("No")}</div>
                            <div className="new">{book.shouldTakeOver ? t("Yes") : t("No")}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Modal {...props} size="lg" centered dialogClassName="save-changes-modal">
            <Modal.Header closeButton className="save-changes-modal-header">
                <div className="title">{t("SaveChanges")}</div>
            </Modal.Header>
            <Modal.Body className="save-changes-modal-content">
                <div className="sub-title">{`${t("ChangeStatusText")}:`}</div>
                {books.map((b) => renderBook(b))}
                <div className="button-wrapper">
                    <Button className="button-cancel" onClick={() => props.onHide()}>
                        {t("Close")}
                    </Button>
                    <Button className="button" onClick={() => submit()}>
                        {t("SaveChanges")}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
